import { createContext, type ReactNode, useContext } from 'react'

export interface TopBarContextType {
  topNavActions: ReactNode | null
  setTopNavActions: (actions: ReactNode | null) => void

  breadcrumbSubtitle: string | null
  setBreadcrumbSubtitle: (subtitle: string | null) => void
}

export const TopBarContext = createContext<TopBarContextType | undefined>(
  undefined,
)

const noop = (): void => {}

const defaultTopBarContext: TopBarContextType = {
  topNavActions: null,
  setTopNavActions: noop,
  breadcrumbSubtitle: null,
  setBreadcrumbSubtitle: noop,
}

export const useTopBar = (): TopBarContextType => {
  const context = useContext(TopBarContext)
  return context ?? defaultTopBarContext
}
